import { Button } from '@cloudscape-design/components';
import { useGetOrgById } from 'hooks/use-basicQueries';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function OrgName({ orgId = null, clickable = false }) {
  const navigate = useNavigate();
  const { data: org = {}, isFetching, isError } = useGetOrgById(orgId);

  if (isFetching) return 'Loading...';
  if (isError || !orgId || !org?.name) return '(Org missing)';

  if (clickable) {
    return (
      <Button variant="inline-link" onClick={() => navigate(`/organization/${orgId}`)}>{org.name}</Button>
    );
  }
  return (
    <span title={org.name}>{org.name}</span>
  );
}

OrgName.propTypes = {
  orgId: PropTypes.string,
  clickable: PropTypes.bool,
};
